<div class="selection">
    <rb-checkbox class="clickable" [checked]="selected" (click)="clicked()"></rb-checkbox>
    <div class="yesplease clickable" [innerHtml]="service.translations.yes" (click)="clicked()"></div>
</div>

<div class="price" [innerHtml]="service.translations.price"></div>
